<template>
  <v-dialog
    v-model="error.user.visible"
    persistent
    width="450"
  >
    <v-card
      color="white"
    >
      <v-toolbar
        dense
        color="red"
        dark
        flat
      >
        <v-icon small>error</v-icon>
        &nbsp;
        {{error.user.title}} | {{error.user.code}}
      </v-toolbar>
      <v-card-text>
        <div
          style="font-weight: 900;"
        >
          {{ error.message }}
        </div>
        <div>
          {{error.technical.details || 'No error message provided.'}}
        </div>
        <br />
        <b>You may need to refresh the page to continue.</b><br />If this error continues to occur, please contact <span class="legalFoot"/> for assistance.
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          flat
          color="red"
          @click="error.user.visible = false"
        >
          Dismiss
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    props: ['error']
}
</script>

